import { useEffect } from "react";
import EventsApi from "../../../api/events";
import { useState } from "react";

// Unopened first-sending reminders link to their own event but continue the first GI flow.
const FLOW_FACING_TYPE_ALIASES = {
  "gi-reminder-12h": "gi",
  "gi-reminder-24h": "gi",
  "gi-reminder-48h": "gi",
};

export function getFlowFacingType(facingType) {
  return FLOW_FACING_TYPE_ALIASES[facingType] || facingType;
}

export function usePatientFacing(eventId=null) {
  const [event, setEvent] = useState(null);
  const [error, setError] = useState(null);

  function fetchEvent(eventId, store=true) {
    setError(null);
    return EventsApi.getEventById(eventId)
      .then(event => {
        setEvent(event)
        if(store) {
          storeEventData(event);
        }
        return event;
      })
      .catch(err => {
        if (err.response?.status === 410) {
          setError({ type: 'expired', message: 'This link has expired - your procedure date has passed.' });
        } else {
          setError({ type: 'error', message: 'Failed to load event data.' });
        }
        throw err;
      });
  }

  // stores event data in session storage
  function storeEventData(eventData) {
    const flowFacingType = getFlowFacingType(eventData?.facingType);
    const flowEventData = eventData && flowFacingType !== eventData.facingType
      ? { ...eventData, facingType: flowFacingType, sourceFacingType: eventData.facingType }
      : eventData;
    sessionStorage.setItem("eventData", JSON.stringify(
      flowEventData
    ));
    // Store facingType separately for analytics
    if (flowFacingType) {
      sessionStorage.setItem("facingType", flowFacingType);
    }
  }

  // retrieves event data from session storage
  function getEventDataLocal() {
    return JSON.parse(sessionStorage.getItem("eventData"));
  }

  useEffect(() => {
    if(eventId) {
      fetchEvent(eventId).catch(() => {}); // Error handled in catch block
    }
  }, [])

  return {
    event,
    error,
    fetchEvent,
    getEventDataLocal,
  };
}